import template from './payment-status.html';
import angular from 'angular';
import './payment-status.scss';
class PaymentStatusController {
    /*@ngInject*/
    constructor() { }
    cancel(notify) {
        this.onCancel({ notify: notify });
    }
}
class PaymentStatusComponent {
    constructor() {
        this.controller = PaymentStatusController;
        this.template = template;
        this.bindings = {
            onCancel: '&',
            status: '<',
            target: '<',
        };
    }
}
export default angular
    .module('doxy.realtime.components.doctor-payment.action.pay.paymentStatus', [])
    .component('paymentStatus', new PaymentStatusComponent()).name;
